"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MissionEditorial() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}